var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default"},[_c('img',{staticClass:"default_img",attrs:{"src":_vm.defaultImg,"alt":""}}),_c('p',{domProps:{"textContent":_vm._s(_vm.defaultText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }